import React from 'react';
import { TextField, MenuItem, Select, InputLabel, FormControl, Button, Box, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const EmployeeForm = ({ employee, index, updateEmployee, removeEmployee, showRemove }) => {
  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      updateEmployee(index, 'photo', file);
    }
  };

  return (
    <Box className="border p-6 mb-6 rounded-lg shadow-lg bg-white">
      <Typography variant="h6" gutterBottom>
        Employee {index + 1}
      </Typography>
      <Box className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <TextField
          label="Employee Code"
          value={employee.empCode}
          onChange={(e) => updateEmployee(index, 'empCode', e.target.value)}
          variant="outlined"
          fullWidth
        />
        <TextField
          label="Employee Name"
          value={employee.empName}
          onChange={(e) => updateEmployee(index, 'empName', e.target.value)}
          variant="outlined"
          fullWidth
        />
        <TextField
          label={employee.greetingType === 'birthday' ? 'Birth Date' : 'Joining Date'}
          type="date"
          value={employee.date}
          onChange={(e) => updateEmployee(index, 'date', e.target.value)}
          variant="outlined"
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="Email"
          type="email"
          value={employee.email}
          onChange={(e) => updateEmployee(index, 'email', e.target.value)}
          variant="outlined"
          fullWidth
        />
        <FormControl fullWidth variant="outlined">
          <InputLabel>Greeting Type</InputLabel>
          <Select
            value={employee.greetingType}
            onChange={(e) => updateEmployee(index, 'greetingType', e.target.value)}
            label="Greeting Type"
          >
            <MenuItem value="birthday">Birthday</MenuItem>
            <MenuItem value="anniversary">Work Anniversary</MenuItem>
          </Select>
        </FormControl>
        <Box>
          <input
            type="file"
            accept="image/*"
            onChange={handlePhotoChange}
            className="border p-3 rounded w-full"
          />
          {employee.photo && (
            <Typography variant="caption" color="textSecondary">
              Selected: {employee.photo.name}
            </Typography>
          )}
        </Box>
      </Box>
      {showRemove && (
        <Button
          variant="contained"
          color="error"
          startIcon={<DeleteIcon />}
          onClick={() => removeEmployee(index)}
          className="mt-4"
        >
          Remove Employee
        </Button>
      )}
    </Box>
  );
};

export default EmployeeForm;
